export default {
    'chatInput.connectionProblems': 'Problem with the internet connection.',
    'chatInput.reconnecting': 'Reconnecting...',
    'chatInput.duplicateMessage': 'You cannot send the same message twice in a row.',
    'chatInput.chatAttachment.uploadFileError': 'An error occurred when sending the file!',
    'chatInput.chatAttachment.fileSizeError': 'It is not possible to upload files larger than 15 MB!',
    'chatInput.chatAttachment.maxFilesError': 'It is not possible to upload more than 5 files at once',
    'chatInput.chatAttachment.sameFileError': 'It is not possible to upload the same file again!',
    'chatInput.autoComplete.edit': 'Edit answer',
    'chatInput.autoComplete.send': 'Send intent',
    'chatInputField.chatInputPlaceholder': 'Ask me something...',
    'chatInputField.chatInputPlaceholderAgentMode': 'Write here to the user...',
    'chatInputField.chatInputPlaceholderFileUploadMode': 'Write what should be done with the content of the file.',
    'chatInputField.suggestionInputPlaceholder': 'Choose one of the options...',
    'speechBubble.dateTime.today' : 'Today',
    'speechBubble.dateTime.at' : 'at',
    'infoPage.privacyPolicyLinkText': 'Privacy policy',
    'infoPage.goBackButtonText': 'Back',
    "chatInput..title.send": "Send message",
    "topBar.title.help": "Info",
    "topBar.title.mini": "Minimize/Maximize",
    "topBar.title.close": "Close chat"
}
